import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Tooltip } from 'antd'
import { RankmiTable } from '@rankmi/rankmi-table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash'
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook'
import { faAdd } from '@fortawesome/pro-solid-svg-icons/faAdd'
import EmptyState from 'components/reusables/emptyState'
import { IBasicCourse } from 'interfaces/course'
import { IProfile } from 'interfaces/profiles'
import Profiles from 'components/reusables/profiles'
import AddCourses from './addCourses'
import { Wrapper, AddCourse, Options } from './styled'

interface IProps {
  data: IBasicCourse[]
  setData: (value: IBasicCourse[]) => void
}

const Courses = ({ data, setData }: IProps) => {
  const { t } = useTranslation()
  const translatePrefix = 'administration.certificate.new'
  const [isAdding, setIsAdding] = useState(false)

  const columns = [
    {
      title: `${t(`${translatePrefix}.courses.nameV2`)}`,
      dataIndex: 'name',
      key: 'name',
      render: (name: string) => <div>{name}</div>,
    },
    {
      title: `${t(`${translatePrefix}.courses.profiles`)}`,
      dataIndex: 'lmsProfiles',
      key: 'lmsProfiles',
      render: (lmsProfiles: IProfile[]) => <Profiles items={lmsProfiles} />,
    },
    {
      width: 66,
      align: 'center',
      fixed: 'right',
      render: (course: IBasicCourse) => (
        <Options>
          <Tooltip title={`${t(`${translatePrefix}.courses.remove`)}`}>
            <Button
              type="link"
              onClick={() =>
                setData(data.filter((item) => item.id !== course.id))
              }
            >
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </Tooltip>
        </Options>
      ),
    },
  ]

  return (
    <Wrapper>
      {data.length > 0 ? (
        <>
          <RankmiTable columnHeaders={columns} data={data} />
          <AddCourse>
            <Button type="link" onClick={() => setIsAdding(true)}>
              <FontAwesomeIcon icon={faAdd} />
              {t(`${translatePrefix}.buttons.associateCourses`)}
            </Button>
          </AddCourse>
        </>
      ) : (
        <EmptyState
          title={t(`${translatePrefix}.emptyState.title`)}
          icon={faBook}
          action={() => setIsAdding(true)}
          actionIcon={faAdd}
          actionTitle={t(`${translatePrefix}.emptyState.actionTitle`)}
          actionBackground={false}
        />
      )}
      {isAdding && (
        <AddCourses
          data={data}
          setData={setData}
          close={() => setIsAdding(false)}
        />
      )}
    </Wrapper>
  )
}

export default Courses
